// extracted by mini-css-extract-plugin
export default {"root":"DeleteButton_root__iEgoq"};